<template>
  <InfuseModal :click-outside="true" :title="t('title')" @close="$emit('close')">
    <div class="flex flex-col gap-4">
      <InfuseField class="w-full" size="small" :label="t('label')">
        <LocaleSwitcher/>
      </InfuseField>

      <hr/>

      <p class="text-xs text-neutral-500 italic mb-[-1rem]">
        {{ getVersion() }}
      </p>
    </div>
  </InfuseModal>
</template>

<script lang="ts" setup>
import { InfuseField, InfuseModal, LocaleSwitcher } from '@infuse/ui/components';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

interface Emits {
  close(): void;
}

defineEmits<Emits>();

function getVersion(): string {
  if (import.meta.env.MODE === 'development') {
    return t('version_dev');
  } else {
    return import.meta.env.VITE_APP_VERSION || '';
  }
}
</script>

<i18n>
{
  "en": {
    "title": "Settings",
    "label": "Change language",
    "version_dev": "development version"
  },
  "nl": {
    "title": "Instellingen",
    "label": "Verander de taal",
    "version_dev": "ontwikkelversie"
  }
}
</i18n>
